<template>
  <div class="pages">
    <mobileHeader title="配送费统计" rightType="scanCode"></mobileHeader>
    <div v-if="userRole == 1" class="select-clerk" @click="selectClerkShow = true">{{selectClerk.text ? selectClerk.text : (columns.length ? "请选择配送员" : "暂无配送员")}}<img src="../../assets/images/xiangzuo_1 (2).png"></div>
    <div class="level-text">等级： {{selectClerk.level ? selectClerk.level : "--"}}</div>
    <div class="print-list">
      <div class="print-item">15KG<div>{{selectClerk['fifteen_kilo'] || '--'}}元/瓶</div></div>
      <div class="print-item">5KG<div>{{selectClerk['five_kilo'] || '--'}}元/瓶</div></div>
      <div class="print-item">50KG<div>{{selectClerk['fifty_kilo'] || '--'}}元/瓶</div></div>
    </div>
    <div class="search-title">配送费查询</div>
    <div class="select-clerk" style="margin-top: 0;margin-bottom: 6vw" @click="selectDateShow = true">{{searchDate ? searchDate : "请选择年月"}}<img src="../../assets/images/xiangzuo_1 (2).png"></div>
    <div class="bottle-number"><div><img src="../../assets/images/gangpin.png" alt=""> 15KG</div><div><van-loading v-if="loading" /><template v-else>{{selectClerk['15KG'] || '-- '}}瓶</template></div></div>
    <div class="bottle-number"><div><img src="../../assets/images/gangpin.png" alt=""> 5KG</div><div><van-loading v-if="loading" /><template v-else>{{selectClerk['5KG'] || '-- '}}瓶</template></div></div>
    <div class="bottle-number"><div><img src="../../assets/images/gangpin.png" alt=""> 50KG</div><div><van-loading v-if="loading" /><template v-else>{{selectClerk['50KG'] || '-- '}}瓶</template></div></div>
    <div class="total-money">
      <img src="../../assets/images/shoufei_3.png" alt="">
      本月{{ userRole == 1 ? (!selectClerk.text ? '门店' : '') : '' }}合计：
      <van-loading v-if="loading" />
      <span v-else>{{selectClerk['delivery_total'] || '-- '}}元</span>
    </div>
    <van-popup v-model="selectClerkShow" position="bottom">
      <van-picker
        title="选择配送员"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup v-model="selectDateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :max-date="maxDate"
        @confirm="onConfirmDate"
        @cancel="onCancelDate"
      />
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import moment from "@/utils/moment.js"
import {getDeliveryClerk, getStatisticsDelivery} from "@/api/deliveryClerk.js"
import { Toast } from 'vant';
export default {
  components: {mobileHeader},
  data(){
    return {
      Toast,
      selectClerk: {},
      selectClerkShow: false,
      columns: [],
      selectDateShow: false,
      currentDate: new Date(),
      searchDate: moment(new Date()).format("YYYY-MM"),
      maxDate: new Date(),
      loading: true
    }
  },
  created(){
    this.getDeliveryClerk()
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    }
  },
  methods: {
    async getDeliveryClerk(){
      const {code, msg, data} = await getDeliveryClerk()
      if(code != 200)return Toast({msg})
        // this.columns = data.map(it => {it.text = it.name;return it})
      if(this.userRole == 1){
        data.unshift({name: "全部", user_id: null})
        this.columns = data.map(it => {it.text = it.name;return it})
        this.getClerkData()
      }else{
        // data[0].user_id = data[0].id
        data.id = data[0].id
        this.selectClerk = data
        this.getClerkData()
      }
    },
    onConfirm(e){
      this.selectClerkShow = false
      this.selectClerk = (e.id == null ? {} : e)
      this.getClerkData()
    },
    onCancel(){this.selectClerkShow = false},
    onConfirmDate(e){
      this.searchDate = moment(e).format("YYYY-MM")
      this.currentDate = e
      this.selectDateShow = false
      this.getClerkData()
    },
    onCancelDate(){
      this.selectDateShow = false
    },
    async getClerkData(){
      this.loading = true
      console.log(this.selectClerk,"this.searchDate")
      const {code, msg, data: {delivery_level, delivery_bottle = {"5KG": "--", "15KG": "--", "50KG": "--"}, delivery_total}} = await getStatisticsDelivery({user_id: this.selectClerk.id, time: this.searchDate})
      this.loading = false
      if(code != 200)return Toast({msg})
      console.log(JSON.stringify([delivery_level, delivery_bottle, delivery_total]))
      delete delivery_level.id;
      this.selectClerk = {...this.selectClerk, ...delivery_level, ...delivery_bottle, delivery_total}
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.select-clerk{
  text-align: center;
  margin: auto;
  margin-top: 2.4vw;
  margin-top: 4.3vw;
  width: 92vw;
  line-height: 12vw;
  border: 1px solid #B5B5B5;
  border-radius: 1.4vw;
  font-size: 5vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4A4A4A;
  position: relative;
  img{
    position: absolute;
    width: 4.3vw;
    height: 2.6vw;
    right: 2.8vw;
    top: 4.8vw;
  }
}
.level-text{
  width: 86vw;
  line-height: 11vw;
  background: linear-gradient(0deg, #FFD156 0%, #FFB71D 100%);
  border-radius: 5.8vw;
  font-size: 5vw;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #392A00;
  text-align: center;
  margin: 4.3vw auto;
}
.print-list{
  line-height: 11.3vw;
  display: flex;
  justify-content: space-between;
  margin: auto;
  width: 92.4vw;
  .print-item{
    text-align: center;
    width: 27vw;
    border-radius: 0px 0px 1.4vw 1.4vw;
    border: 1px solid #FFC300;
    font-size: 6vw;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #4A4A4A;
    div{
      background: linear-gradient(0deg, #FFFFFF 0%, #FFC600 0%, #FCAC00 100%);
      font-size: 5vw;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #392A00;
    }
  }
}
.search-title{
  width: 88vw;
  border-top: 1px solid #BFBFBF;
  margin-left: 6vw;
  margin-top: 3.6vw;
  line-height: 14vw;
  height: 14vw;
  text-align: center;
  font-size: 5vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #4A4A4A;
}
.bottle-number{
  width: 90%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3vw;
  font-size: 5vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #4A4A4A;
  img{
    width: 4.2vw;
    height: 6.4vw;
    margin-right: 2.4vw;
  }
  & > div:nth-child(1){
    display: flex;
    align-items: center;
  }
  & > div:nth-child(2){
    width: 70%;
    line-height: 9.9vw;
    border: 1px solid #B5B5B5;
    border-radius: 1.4vw;
    text-align: center;
    ::v-deep .van-loading{
      width: 200px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
.total-money{
  display: flex;
  align-items: center;
  font-size: 5vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #4A4A4A;
  line-height: 8.9vw;
  img{
    height: 8.9vw;
    width: 8.9vw;
    margin-right: 2.5vw;
    margin-left: 5vw;
  }
  span{
    font-size: 6.7vw;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #343434;
  }
}
</style>